export default __webpack_public_path__ + "static/media/SAS Alert Tone 2.0dc2abb9.wav";